<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Esquema de Puntos</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col form-group">
							<label for="name" class="form-label">Nombre Esquema <span class="required">*</span></label>
							<input type="text" placeholder="Ingresa el nombre del esquema" name="name" id="name"
								[(ngModel)]="newSchema.nombre" class="form-control">
						</div>
						<div class="col form-group">
							<label for="quetzals" class="form-label">Cantidad en Quetzales <span
									class="required">*</span></label>
							<input type="number" placeholder="Quetzales" name="quetzals" id="quetzals"
								[(ngModel)]="newSchema.quetzals" class="form-control">
						</div>
						<div class="col form-group">
							<label for="points" class="form-label">Total Puntos <span class="required">*</span></label>
							<input type="number" placeholder="Puntos" name="points" id="points"
								[(ngModel)]="newSchema.points" class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col form-group">
							<label for="cash" class="form-label">Efectivo <span class="required">*</span></label>
							<input type="number" placeholder="Efectivo" name="cash" id="cash"
								[(ngModel)]="newSchema.cash" class="form-control">
						</div>
						<div class="col form-group">
							<label for="credit" class="form-label">Crédito <span class="required">*</span></label>
							<input type="number" placeholder="Crédito" name="credit" id="credit"
								[(ngModel)]="newSchema.credit" class="form-control">
						</div>
						<div class="col form-group">
							<label for="transfer" class="form-label">Transferencia <span
									class="required">*</span></label>
							<input type="number" placeholder="Transferencia" name="transfer" id="transfer"
								[(ngModel)]="newSchema.transfer" class="form-control">
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para guardar los cambios</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="loading || !newSchema.nombre || !newSchema.quetzals || !newSchema.points || !newSchema.cash || !newSchema.credit || !newSchema.transfer"
						(click)="create()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>